<template>
  <v-app class="application--is-rtl main-app" app-data="true">

    <NavBar />
    <div class="inner-wrap">
      <div class="banner-wrap  ">
        <Banner class="pc-banner " :is-hitech="false" />
      </div>
      <personalNav v-if="isLogged" />
      <div class="section_inner">
        <UserDetails v-if="isLogged" />
        <!-- <PersonalGeneric class="mb-6"/> -->
        <v-layout column :class="isLogged ? null : 'mt-5'">
          <v-flex>
            <v-layout wrap justify-space-between>
              <v-flex sm12 md8 lg10 class="jobs-row">
                <Nuxt />
              </v-flex>

              <v-flex class="ads-row d-lg-block d-md-block d-sm-none">
                <v-layout colomun wrap>
                  <v-flex>
                    <SectionCompaniesInnerPages :page="'personalPage'" />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <Footer class="footer-wrap" />
    <Snackbar />
    <AlertDialog />
    <FormDialog />
  </v-app>
</template>

<script>
import NavBar from '@/components/NavigationMenu/NavBar';
import Footer from '@/components/Footer/Footer';

// import PersonalGeneric from '@/components/Banners/PersonalGeneric/PersonalGeneric'
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';
import personalNav from '@/components/Candidates/NavBar/personalNav';
import UserDetails from '@/components/Candidates/UserDetails/UserDetails';
import Snackbar from '@/components/Snackbar/Snackbar';
import AlertDialog from '@/components/Dialogs/AlertDialog/AlertDialog';
import FormDialog from '@/components/Dialogs/FormDialog';
import Banner from '@/components/Jobs_List/Banner';
import CurrentUser from '@/components/mixins/CurrentUser';
import BrazeUserSetup from '@/components/mixins/BrazeUserSetup';


export default {
  name: 'LayoutPersonal',
  mixins: [CurrentUser, BrazeUserSetup],
  components: {
    SectionCompaniesInnerPages,
    personalNav,
    UserDetails,
    NavBar,
    Footer,
    Snackbar,
    AlertDialog,
    FormDialog,
    Banner,

    // PersonalGeneric
  },

  data() {
    return {
      showIflogged: false,
    };
  },

  beforeCreate() {
    let currentPath = this.$route.path;
    switch (currentPath) {
      case '/personal/myboard':
        if (!this.$store.state.auth.loggedIn) {
          this.$router.push('/enter/login');
        }
        break;
    }
  },
};
</script>

<style lang="scss" scoped>
.inner-wrap {
  min-height: 50vh;
}

.theme--light.v-list {
  background: transparent;
}

.ads-row {
  max-width: 300px;
}

.job-item {
  border-right: 9px solid #f2f0ef;
}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.filter-btn {
  margin: 0;
  margin-left: 14px;
  border: solid 1px #e3e4e6;
  background-color: rgba(46, 40, 36, 0);
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 5px 10px;
  letter-spacing: -1px;
  font-size: 12px;
}

.filter-by-text {
  display: none;
}

.filter-icon {
  display: inline-block;
  margin-left: 6px !important;
}

.filter-icon:before {
  color: #000;
}

.filter-btn:hover {
  border: 1px solid #000;
}

h3 {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: -0.9px;
}

.aside-ad {
  background: #3e4a54;
  text-align: center;
}

@media only screen and (min-width: 600px) {
  .inner-content {
    padding: 0;
  }
}

@media only screen and (min-width: 700px) {
  .filter-by-text {
    display: block;
  }

  .filter-btn {
    margin: 0;
    height: 50px;
    width: 200px;
    margin-left: 14px;
    border: solid 1px #e3e4e6;
    background-color: rgba(46, 40, 36, 0);
    display: inline-flex;
    align-items: center;
    padding: 5px 10px 5px 10px;
    letter-spacing: -1px;
    font-size: 24px;
  }
}

@media screen and (min-width: 1280px) {
  .jobs-row {
    max-width: 934px;
  }
}

@media screen and (max-width: 600px) {
  .ads-row {
    display: none;
  }
}
</style>
